import { CustomCard } from "@/components";
import { IPrAffiliate } from "@/models";
import { RouteNames } from "@/router";
import { Component, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({
    components: {
        CustomCard,
        draggable,
    },
})
export default class PrAffiliates extends Vue {
    public RouteNames = RouteNames;

    public filterText = "";

    public currentPage = 1;

    public itemsPerPage = 100;

    public filteredPrAffiliates: IPrAffiliate[] = [];

    public slicedPrAffiliates: IPrAffiliate[] = [];

    public get prAffiliates(): IPrAffiliate[] {
        return this.$store.getters["app/prAffiliates"];
    }

    public headers: any[] = [
        {
            value: "name",
            sortable: true,
            text: "Name",
        },
        { text: "Code", sortable: true, value: "code" },
        { text: "Type", sortable: true, value: "type" },
    ];

    @Watch("filterText")
    watchFitlerText(value): void {
        this.currentPage = 1;
        this.computeFilteredPrAffiliates(value);
    }

    computeFilteredPrAffiliates(filterText = this.filterText) {
        if (filterText != null && filterText.length > 0) {
            this.filteredPrAffiliates = this.prAffiliates.filter(curr => {
                return curr.name.toUpperCase().includes(filterText.toUpperCase());
            });
            return;
        }
        this.filteredPrAffiliates = this.prAffiliates;
    }

    @Watch("filteredPrAffiliates")
    handleFilteredPrAffiliates() {
        this.doPrepareSlicedPrAffiliates();
    }
    @Watch("currentPage")
    handleCurrentPage() {
        this.doPrepareSlicedPrAffiliates();
    }
    @Watch("itemsPerPage")
    handleItemsPerPage() {
        this.doPrepareSlicedPrAffiliates();
    }

    doPrepareSlicedPrAffiliates() {
        this.slicedPrAffiliates = this.filteredPrAffiliates;
    }

    getTypeString(type: number) {
        let result = "";
        switch ( type ) {
            case 1:
                result = "Brand Co";
                break;
            case 2:
                result = "Market Co";
                break;
            case 3:
                result = "Other team";
                break;
            default:
                result = "Brand Co";
                break;
        }
        return result;
    }

    get numberOfPages(): number {
        const result = this.filteredPrAffiliates.length / this.itemsPerPage;

        if (result > Math.floor(result)) return Math.floor(result) + 1;

        return result;
    }

    async mounted(): Promise<void> {
        await this.$store.dispatch("app/loadAllPrAffiliate");
        this.computeFilteredPrAffiliates();
        this.doPrepareSlicedPrAffiliates();
    }
}
